import React from 'react'
import {Divider, Steps, Row, Col, Input, Select, Checkbox, DatePicker,
    Button, Table, Popconfirm, TreeSelect, Tooltip, message,
    BackTop, Spin, Tabs, Modal} from 'antd'
import common from '@/public/common'
import './list.less'
import { withRouter } from 'react-router-dom'
import {ajaxApi, postMethodDepartment, getMethod, submitMethod} from '@/server'
import { summation, getCookieNew, getParmUrl, outputMoney } from '../../public/utils'
import DateChoose from '../../compenents/dateChoose'
import moment from 'moment'
const { Step } = Steps
const { Option } = Select
const { TabPane } = Tabs
const { TextArea } =Input
const urlLink = common.SapUrl

class SendDetails extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
          sping: false,
          info: {}
        }
    }
    componentDidMount () {
       this.getDetails()
    }
    getDetails = () => {
        this.setState({
            sping: true
        }, () => {
            let param = {
                code: getParmUrl('code')
            }
            let _item = getCookieNew('supplierinfo') ? JSON.parse(getCookieNew('supplierinfo')).code : ''
            getMethod(urlLink + '/document/query-detail-out/'+ getParmUrl('code') + '/' + _item).then(res => {
               if (res.data) {
                   this.setState({
                       info: res.data,
                       sping: false
                   })
               }
            })
        })
    }
    render () {
        const { sping, info } = this.state
        return (
            <div className="addSend">
                <Spin spinning={sping}>
                <h1>{'寄送单详情（单号：' + getParmUrl('code')+'）'}</h1>
                <Divider/>
                <div className="sendDetails">
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>单据类型：</label>
                            <span>{info.type_name}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>单据状态：</label>
                            <span>{info.status_name}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>寄件人：</label>
                            <span>{info.sender}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>寄件日期：</label>
                            <span>{info.send_date ? moment(info.send_date).format('YYYY-MM-DD') : ''}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>对账单号：</label>
                            <span>{info.reconciliation_code}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>供应商代码：</label>
                            <span>{info.supplier_code}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>供应商名称：</label>
                            <span>{info.supplier_name}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>快递公司：</label>
                            <span>{info.logistics_name}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>快递单号：</label>
                            <span>{info.logistics_code}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>签收日期：</label>
                            <span>{info.sign_date ? moment(info.sign_date).format('YYYY-MM-DD'):''}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>签收人：</label>
                            <span>{info.signer}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>拒收原因：</label>
                            <span>{info.rejection_reason}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>回寄快递单号：</label>
                            <span>{info.rejection_logistics_code}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label>回寄快递公司：</label>
                            <span>{info.rejection_logistics_name}</span>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '20px'}}>
                        <Col span={10}>
                            <label style={{float: 'left'}}>备注：</label>
                            <span>{info.remark}</span>
                        </Col>
                    </Row>
                </div>
                {/* <div className="button">
                    <Button style={{marginRight: '20px'}}>返回</Button>
                </div> */}
                </Spin>
            </div>
        )
    }

}
export default SendDetails



// WEBPACK FOOTER //
// ./src/pages/supplierRecantion/sendDetails.js